const CryptoJS = require("crypto-js"); 
export default function decrypt (data){
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRP);
    const message = data;
    const iv =  CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRP);
    const decrypt = CryptoJS.AES.decrypt(message, key, {
            keySize:16,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    return CryptoJS.enc.Latin1.stringify(decrypt);
}